var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sidebar-container" }, [
    _c("div", { staticClass: "sidebar-header" }, [
      _c(
        "div",
        { staticClass: "sidebar-title" },
        [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.data.issueReference) +
                "\n            "
            ),
          ]),
          _c(
            "md-button",
            {
              staticClass: "md-default md-just-icon md-round pull-right",
              on: { click: _vm.closeModal },
            },
            [_c("md-icon", [_vm._v("close")])],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "issueReference" }, [
        _vm._v("\n            " + _vm._s(_vm.data.title) + "\n        "),
      ]),
    ]),
    _c("div", { staticClass: "sidebar-separator" }),
    _c("div", { staticClass: "sidebar-content" }, [
      _c("div", { staticClass: "sidebar-section" }, [
        _c(
          "div",
          { staticClass: "detail-item" },
          [
            _c("label", [_vm._v("Status:")]),
            _c("issue-status-button", {
              staticClass: "sidebar-section-item",
              attrs: { issue: _vm.data },
              on: { statusUpdated: _vm.handleStatusChange },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "detail-item" }, [
          _c("label", [_vm._v("Created By:")]),
          _c("span", { staticClass: "sidebar-section-item" }, [
            _vm._v(_vm._s(_vm.data.createdByName)),
          ]),
        ]),
        _c("div", { staticClass: "detail-item" }, [
          _c("label", [_vm._v("Created Date:")]),
          _c("span", { staticClass: "sidebar-section-item" }, [
            _vm._v(
              "\n                    " +
                _vm._s(
                  _vm._f("dateFormat")(
                    _vm.data.createdDate,
                    _vm.DATE_TYPES.standardDateTime
                  )
                ) +
                "\n                "
            ),
          ]),
        ]),
        _c("div", { staticClass: "detail-item" }, [
          _c("label", [_vm._v("Last Updated By:")]),
          _c("span", { staticClass: "sidebar-section-item" }, [
            _vm._v(_vm._s(_vm.data.lastModifiedByName)),
          ]),
        ]),
        _c("div", { staticClass: "detail-item" }, [
          _c("label", [_vm._v("Last Updated:")]),
          _c("span", { staticClass: "sidebar-section-item" }, [
            _vm._v(
              "\n                    " +
                _vm._s(
                  _vm._f("dateFormat")(
                    _vm.data.lastModifiedDate,
                    _vm.DATE_TYPES.standardDateTime
                  )
                ) +
                "\n                "
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "sidebar-section" }, [
        _c("h5", [_vm._v("Related To")]),
        _c("div", { staticClass: "detail-item" }, [
          _c("label", [_vm._v("Type:")]),
          _c("span", { staticClass: "sidebar-section-item" }, [
            _vm._v(_vm._s(_vm.data.relatedEntityType)),
          ]),
        ]),
        _c("div", { staticClass: "detail-item" }, [
          _c("label", [_vm._v("Reference:")]),
          _c(
            "span",
            { staticClass: "sidebar-section-item" },
            [_c("issue-routed-entity", { attrs: { item: _vm.data } })],
            1
          ),
        ]),
      ]),
      _c("div", { staticClass: "sidebar-separator" }),
      _c("div", { staticClass: "sidebar-section logs-section" }, [
        _c("h5", [_vm._v("Issue Logs")]),
        _c(
          "div",
          { staticClass: "issue-logs" },
          _vm._l(_vm.data.issueLogs, function (log, index) {
            return _c("div", { key: index, staticClass: "issue-log" }, [
              _c("div", { staticClass: "log-header" }, [
                _c("span", { staticClass: "log-author" }, [
                  _vm._v(_vm._s(log.createdByName)),
                ]),
                _c("span", { staticClass: "log-date" }, [
                  _vm._v(
                    "\n                            " +
                      _vm._s(
                        _vm._f("dateFormat")(
                          log.lastModifiedDate,
                          _vm.DATE_TYPES.standardDateTime
                        )
                      ) +
                      "\n                        "
                  ),
                ]),
              ]),
              _c("div", [
                _vm._v(
                  "\n                        " +
                    _vm._s(log.note) +
                    "\n                    "
                ),
              ]),
            ])
          }),
          0
        ),
        _c(
          "div",
          { staticClass: "add-log" },
          [
            _c(
              "md-field",
              [
                _c("label", [_vm._v("Add Note")]),
                _c("md-textarea", {
                  staticClass: "add-log-textarea",
                  model: {
                    value: _vm.newLogText,
                    callback: function ($$v) {
                      _vm.newLogText = $$v
                    },
                    expression: "newLogText",
                  },
                }),
              ],
              1
            ),
            _c(
              "md-button",
              { staticClass: "md-primary", on: { click: _vm.addLog } },
              [_vm._v("Add")]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }